module.exports = __webpack_public_path__ + "static/logo-purple-full-4019728891702146fcf681471716b50f.svg";